import { PopoverMenu } from "antd-mobile/es/components/popover/popover-menu"
import styled from "styled-components"

export const DropdownTrigger = styled.div<{ $isActive: boolean }>`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--Schemes-Surface-Container, #ebedf0);
  cursor: pointer;
  border: 1px solid
    ${({ $isActive }) =>
      $isActive
        ? "var(--Schemes-Primary-Container, #4BD9DE)"
        : "transparent"};
`

export const DropdownValue = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 160%;
`

export const DropdownMenu = styled(PopoverMenu)`
  --arrow-size: 0px;

  .adm-popover-menu-list-inner {
    padding: 4px 0px;
  }

  .adm-popover-menu-item {
    svg {
      width: 16px;
      height: 16px;
    }

    padding-left: 0px;
    width: 173px;

    &:first-child {
      .adm-popover-menu-item-text {
        border-top: none;
      }
    }

    .adm-popover-menu-item-text {
      padding: 8px 12px;
      line-height: 22px;
      font-weight: 400;
      font-size: 14px;
    }
  }
`

export const ActionLabel = styled.span<{ $isSelected: boolean }>`
  font-weight: ${({ $isSelected }) => ($isSelected ? 700 : 400)};
  font-size: 14px;
  line-height: 160%;
`
